import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const SubCategoryCreate = () => {
  const navigate = useNavigate();

  const initialForm = {
    subcategory_name: "",
    category_id: "",
    status: "",
  };

  const [form, setForm] = useState(initialForm);
  const [imageFile, setImageFile] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
  const [categories, setCategories] = useState([]);

  // --------------------------
  // HANDLE INPUT
  // --------------------------
  const handleInput = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  // --------------------------
  // HANDLE IMAGE
  // --------------------------
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setImageFile(file);

    if (file) {
      setPreviewImage(URL.createObjectURL(file));
    }
  };

  // --------------------------
  // SUBMIT FORM
  // --------------------------
  const submitForm = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("subcategory_name", form.subcategory_name.trim());
    formData.append("category_id", form.category_id);
    formData.append("status", form.status);
    formData.append("image", imageFile);

    try {
      const response = await axios.post(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/add_main_subcategory",
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      if (response.data.status === true) {
        toast.success("Subcategory added successfully!");
        setForm(initialForm);
        setImageFile(null);
        setPreviewImage(null);
        navigate("/sub-category-list");
      } else {
        toast.error(response.data.message || "Failed to add subcategory");
      }
    } catch (error) {
      console.error("API Error:", error);
      toast.error("Something went wrong!");
    }
  };

  // --------------------------
  // FETCH CATEGORY LIST
  // --------------------------
  useEffect(() => {
    const fetchCategory = async () => {
      try {
        const response = await axios.get(
          "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_main_category"
        );

        if (Array.isArray(response.data.row)) {
          setCategories(response.data.row);
        } else {
          setCategories([]);
        }
      } catch (error) {
        console.error("Category Fetch Error:", error);
      }
    };

    fetchCategory();
  }, []);

  return (
    <div className="page-content">
      <div className="container-fluid">

        {/* PAGE TITLE */}
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0 fw-semibold">Create Sub Category</h4>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <a href="#">Sub Category</a>
                </li>
                <li className="breadcrumb-item active">Create Sub Category</li>
              </ol>
            </div>
          </div>
        </div>

        {/* FORM */}
        <div className="row">
          <div className="col-xl-9 col-lg-8 ">
            <form onSubmit={submitForm} encType="multipart/form-data">

              {/* IMAGE CARD */}
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title">Add Image</h4>
                </div>
                <div className="card-body">
                  <div className="dropzone bg-light-subtle py-5">
                    <label className="form-label text-dark">Image</label>
                    <input
                      type="file"
                      className="form-control"
                      accept="image/*"
                      onChange={handleImageChange}
                    />

                    {previewImage && (
                      <img
                        src={previewImage}
                        alt="preview"
                        className="mt-2"
                        style={{ width: "100px" }}
                      />
                    )}
                  </div>
                </div>
              </div>

              {/* GENERAL INFORMATION */}
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title">General Information</h4>
                </div>

                <div className="card-body">
                  <div className="row">

                    {/* Subcategory Name */}
                    <div className="col-lg-6 mb-3">
                      <label className="form-label">Subcategory Title</label>
                      <input
                        type="text"
                        className="form-control"
                        name="subcategory_name"
                        placeholder="Enter Title"
                        value={form.subcategory_name}
                        onChange={handleInput}
                      />
                    </div>

                    {/* CATEGORY DROPDOWN */}
                    <div className="col-lg-6 mb-3">
                      <label className="form-label">Category</label>
                      <select
                        className="form-control"
                        name="category_id"
                        value={form.category_id}
                        onChange={handleInput}
                      >
                        <option value="">-- Select Category --</option>

                        {categories.map((cat) => (
                          <option
                            key={cat.category_id}
                            value={cat.category_id}
                          >
                            {cat.category_name}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* STATUS */}
                    <div className="col-lg-6 mb-3">
                      <label className="form-label">Status</label>
                      <select
                        className="form-control"
                        name="status"
                        value={form.status}
                        onChange={handleInput}
                      >
                        <option value="">-- Select Status --</option>
                        <option value="Active">Active</option>
                        <option value="Inactive">Inactive</option>
                      </select>
                    </div>

                  </div>
                </div>
              </div>

              {/* BUTTONS */}
              <div className="p-3 bg-light mb-3 rounded">
                <div className="row justify-content-end g-2">
                  <div className="col-lg-2">
                    <button type="submit" className="btn btn-outline-secondary w-100">
                      Save Change
                    </button>
                  </div>
                  <div className="col-lg-2">
                    <Link to="/sub-category-list" className="btn btn-primary w-100">
                      Cancel
                    </Link>
                  </div>
                </div>
              </div>

            </form>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="footer">
        <div className="container-fluid text-center">
          © Venton. Crafted with ♥ by Techzaa
        </div>
      </footer>
    </div>
  );
};

export default SubCategoryCreate;
